import {
  commonStructure,
  handleEntitiesUpdate,
  dataResponseHandler,
  dataFetchingHandler
} from './reducer.helper'

import * as types from '../types/spaceEntity'

const initialState = {
  centreData: commonStructure()
}

const spaceEntityReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_CENTRE_DATA:
      return dataFetchingHandler(state, `${action.entity}Data`, action)

    case types.FETCH_CENTRE_DATA_SUCCESS:
      return dataResponseHandler(state, `${action.entity}Data`, action)

    case types.UPDATE_SPACE_DATA_SUCCESS:
      return handleEntitiesUpdate(state, action)

    default:
      return state
  }
}

export { spaceEntityReducer }
